import React, { useState, useEffect } from "react";
import MessageSVG from "assets/images/message-box.svg";
import ActivationSVG from "assets/images/fluent-emoji-high-contrast_ticket.svg";
import BarCode from "assets/images/barcode-sign-free-png 1.svg";
import { activateKit, errorClean, messageClean } from "redux-store/kit/kit.slice";
import { successMessage, kitError, kitActivityInProcess } from "redux-store/kit/kit.selector";
import { AppDispatch } from "redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import "./steptwo.css";
type Propstype = {
  changeStep?: (step: string) => void;
  setKitData?: (data: any) => void;
  kitData?: any;
  purchaseDetails?: {
    online: { checked: boolean; reason: string };
    vetClinics: { checked: boolean; reason: string };
    petSupplyStores: { checked: boolean; reason: string };
    petInsurance: { checked: boolean; reason: string };
    petTeleVet: { checked: boolean; reason: string };
  };
};
const StepTwo = ({ changeStep, setKitData, kitData }: Propstype) => {
  const kiterrorMessage = useSelector(kitError);
  const dispatch = useDispatch<AppDispatch>();
  const kitMessage = useSelector(successMessage);
  const [selectedOptions, setSelectedOptions] = useState({
    online: { checked: false, reason: "" },
    vetClinics: { checked: false, reason: "" },
    petSupplyStores: { checked: false, reason: "" },
    petInsurance: { checked: false, reason: "" },
    petTeleVet: { checked: false, reason: "" },
  });
  const optionsMap: { [key: string]: keyof typeof selectedOptions } = {
    "E-commerce store ": "online",
    "Vet Clinics": "vetClinics",
    "Pet Supply Stores": "petSupplyStores",
    "Pet Insurance": "petInsurance",
    "Pet Televet": "petTeleVet",
  };

  const isAtLeastOneChecked = Object.values(selectedOptions).some((option) => option.checked);

  const [otp, setOtp] = useState("");
  const handleClick = () => {
    if (!setKitData) {
      console.error("setKitData is undefined!");
      return;
    }
    if (!isAtLeastOneChecked) {
      return alert("Please select at least one option");
    }
    const updatedKitData = {
      ...kitData,
      code: otp,
      purchaseDetails: selectedOptions,
    };
    setKitData(updatedKitData);
    if (kitMessage !== "") {
      dispatch(messageClean());
      dispatch(errorClean());
    } else {
      dispatch(
        activateKit({
          kitId: otp,
          purchaseDetails: updatedKitData.purchaseDetails,
        })
      );
    }
  };
  useEffect(() => {
    if (kitMessage === "Code matched successfully" && changeStep) {
      changeStep("step3");
    }
  }, [kitMessage, changeStep]);

  useEffect(() => {
    dispatch(messageClean());
    dispatch(errorClean());
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;

    if (!checked) return; // Prevent unchecking all checkboxes

    const key = optionsMap[value];

    // Reset all options and select only the current one
    setSelectedOptions({
      online: { checked: key === "online", reason: "" },
      vetClinics: { checked: key === "vetClinics", reason: "" },
      petSupplyStores: { checked: key === "petSupplyStores", reason: "" },
      petInsurance: { checked: key === "petInsurance", reason: "" },
      petTeleVet: { checked: key === "petTeleVet", reason: "" },
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, key: keyof typeof selectedOptions) => {
    const { value } = e.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [key]: { ...prev[key], reason: value },
    }));
  };

  return (
    //   main
    <div className="tw-flex tw-flex-col tw-gap-4">
      {/* Where did you purchase */}
      <div className="tw-flex tw-flex-col tw-justify-start">
        <div className="tw-text-[1.25rem] lg:tw-text-[2.25rem] tw-font-bold lg:tw-leading-[2.6875rem]">
          Where did you purchase your kit? (required)
        </div>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-2">
          {Object.entries(optionsMap).map(([label, key]) => (
            <label
              key={key}
              className="tw-flex tw-items-center tw-gap-2 tw-text-[0.875rem] lg:tw-text-[1.25rem] tw-text-gray-700"
            >
              <input
                type="checkbox"
                className="tw-w-4 tw-h-4 tw-accent-reddishOrange"
                value={label}
                onChange={handleChange}
                checked={selectedOptions[key].checked}
              />
              {label}
              {selectedOptions[key].checked && (
                <input
                  type="text"
                  className=" flex tw-justify-start tw-items-start tw-border tw-border-gray-300 tw-rounded-md tw-p-2 tw-text-[0.875rem] lg:tw-text-[1.25rem] tw-h-10 tw-w-[250px] tw-focus:ring-2 tw-focus:ring-reddishOrange tw-outline-none"
                  placeholder="Type Name"
                  value={selectedOptions[key].reason}
                  onChange={(e) => handleInputChange(e, key)}
                />
              )}
            </label>
          ))}
        </div>
      </div>

      {/* 1st main row */}
      <div className="tw-flex tw-items-center tw-gap-4">
        {/* 1st inner row */}

        <div className="tw-w-fit tw-flex tw-items-center tw-justify-center tw-p-1 lg:tw-p-3 tw-rounded-full tw-bg-reddishOrange">
          <img src={ActivationSVG} />
        </div>

        {/* 2nd inner row */}
        <div className="tw-flex tw-flex-col tw-justify-start">
          <div className="tw-text-[1.25rem] lg:tw-text-[2.25rem] tw-font-bold lg:tw-leading-[2.6875rem]">
            Activate your kit
          </div>
          <div className="tw-flex tw-items-center tw-gap-1 tw-text-[0.875rem] lg:tw-text-[1.25rem] lg:tw-leading-[1.5rem] tw-text-reddishOrange">
            <div>
              <img src={MessageSVG} />
            </div>
            <a
              href="mailto:hello@oncotect.co"
              className="tw-text-reddishOrange focus:!tw-text-reddishOrange"
              style={{ textDecoration: "none" }}
            >
              Need help? Contact us
            </a>
          </div>
        </div>
      </div>

      {/* 2nd main row */}
      <div className="tw-flex tw-flex-col tw-gap-10 lg:tw-flex-row">
        {/* left  row */}
        <div className="tw-flex-[2] tw-flex tw-items-center tw-gap-0 sm:tw-gap-6 ">
          {/* 1st inner row */}
          <div className="tw-invisible tw-w-fit tw-flex tw-items-center tw-justify-center tw-p-1 lg:tw-p-3 tw-rounded-full tw-bg-reddishOrange">
            <img src={ActivationSVG} alt="activation" />
          </div>
          {/* 2nd inner row */}
          <div className="tw-flex tw-flex-col tw-gap-6">
            {/* 1st col */}
            <div>
              <p className="tw-font-ligh tw-text-[0.705rem] lg:tw-text-[1.625rem] lg:tw-leadng-[1.9375rem]">
                Enter 6-digit activation code found on the test kit.
              </p>
            </div>
            {/* 2nd col */}
            <div className="tw-flex tw-flex-col tw-gap-3">
              {/* input boxes col */}
              <div className=" tw-w-3/4 tw-flex tw-items-center tw-gap-1 min-[550px]:tw-gap-2">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  // renderSeparator={<span>-</span>}
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      className="tw-text-center tw-rounded-[0.3125rem] lg:tw-text-[3.425rem] md:tw-text-[2.925rem] tw-text-[1.725rem] tw-text-reddishOrange tw-bg-[#ffddd2] focus:tw-outline-none focus:tw-bg-reddishOrange focus:tw-text-white tw-flex tw-mx-4"
                      key={index}
                      inputMode="numeric"
                      type="number"
                    />
                  )}
                  inputStyle={{ marginLeft: "6px" }}
                />
              </div>
              {/* text col */}
            </div>
            {/* 3rd col */}
            <span className="tw-text-xs tw-text-red-500">
              {kiterrorMessage.message !== "" ? "Activation code is Incorrect" : ""}
            </span>
            <div className="">
              <button
                className=" tw-py-1 lg:tw-py-2 tw-px-8 lg:tw-px-14 tw-text-[0.875rem] lg:tw-text-[1.25rem] tw-rounded-[0.625rem] tw-border-[1px] lg:tw-border-2 tw-border-solid tw-border-darkRed"
                // className="tw-px-14 tw-py-2 tw-rounded-[0.625rem] tw-border-2 tw-border-solid tw-border-darkRed"
                onClick={handleClick}
                // disabled={!isAtLeastOneChecked}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
